var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"poweredby"}},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.brands),function(brand,index){return _c('span',{key:index},[_c('a',{attrs:{"href":brand.link,"target":"_blank","title":brand.tip}},[_c('img',{attrs:{"src":brand.image}})])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a5f972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PoweredByWidget.vue
// module id = null
// module chunks = 